export default __webpack_public_path__ + "static/media/rumble-full-logo.7d38f03b.svg";